import * as React from 'react';
import determineMeetingResponseIcon from '../utils/determineMeetingResponseIcon';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';
import { mergeOverrideStyles } from 'mini-styles/lib/utils/mergeOverrideStyles';
import { PersonaMeetingResponse, PersonaSize } from '..';
import { SIZE_TO_PIXELS } from './PersonaConsts';

const styles = require('./Persona.scss');
const classNames = require('classnames/bind').bind(styles);

export interface PersonaMeetingResponseBadgeProps {
    personaSize: PersonaSize;
    meetingResponse: PersonaMeetingResponse;
}

/**
 * An indicator on the attendee persona representing whether the meeting has been accepted or declined
 */
export default class PersonaMeetingResponseBadge extends React.Component<
    PersonaMeetingResponseBadgeProps,
    {}
> {
    render() {
        const { meetingResponse, personaSize } = this.props;

        if (
            meetingResponse === undefined ||
            meetingResponse === null ||
            meetingResponse === PersonaMeetingResponse.Unknown
        ) {
            return null;
        }

        const badgeSize = _getMeetingResponseBadgeSize(personaSize);
        const iconSizeStyles = mergeOverrideStyles({
            height: badgeSize + 'px',
            width: badgeSize + 'px',
        });

        return (
            <FluentSvgIcon
                icon={determineMeetingResponseIcon(this.props.meetingResponse, true /** isSolid */)}
                iconContainerStyles={classNames(styles.personaResponseStatus, iconSizeStyles, {
                    accept: meetingResponse === PersonaMeetingResponse.Accept,
                    decline: meetingResponse === PersonaMeetingResponse.Decline,
                    tentative: meetingResponse === PersonaMeetingResponse.Tentative,
                })}
            />
        );
    }
}

function _getMeetingResponseBadgeSize(personaSize: PersonaSize) {
    const personaSizeInPixels = SIZE_TO_PIXELS[personaSize];
    if (personaSizeInPixels < 32) {
        return 10;
    } else if (personaSizeInPixels <= 48) {
        return 12;
    } else {
        return 16;
    }
}
